import { render, staticRenderFns } from "./payWay.vue?vue&type=template&id=37d40480&scoped=true"
import script from "./payWay.vue?vue&type=script&lang=js"
export * from "./payWay.vue?vue&type=script&lang=js"
import style0 from "./payWay.vue?vue&type=style&index=0&id=37d40480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d40480",
  null
  
)

export default component.exports